import { render, staticRenderFns } from "./RolesManager.vue?vue&type=template&id=6e23b147&"
import script from "./RolesManager.vue?vue&type=script&lang=ts&"
export * from "./RolesManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports